import { getAuthStoreData } from 'store/auth/accessors';

export const isPrivate = (): boolean => {
    const authState = getAuthStoreData();

    if (!authState) {
        return false;
    }

    return authState?.isAuthenticated && authState?.isComplete;
};

export const isNotPrivate = () => !isPrivate();
